define('Components/BannerWidget/js/models/BannerWidgetInstanceModel',['jquery','WidgetInstanceModel','app'],function($,WidgetInstanceModel,app){

    function isMobile(){
        return app.isMobile();
    }

    function suffixMobile(){
        return isMobile() ? '_mobile':'';
    }

    return WidgetInstanceModel.extend({
        getImage: function(suffix,format){

            // default picture settings
            suffix = suffix ? suffix : '1920x1080';
            format = format ? format : 'JPG';

            var model = this,
                id_picture = model.p('image'),id_picture_mobile,
                baseline = model.get('baseline'),
                url;
            if(app.isMobile()){
                id_picture_mobile = model.p('image_mobile');
                var template = model.p('template');
                if(id_picture_mobile === '0'){
                    // gestion du cas ou 'image_mobile' vaut 0
                    // ça a lieu pour certaines version du template
                    // où le desktop à un arrière-plan, mais le mobile ne doit rien afficher.
                    if(template === 'image-seo'){
                        suffix = 'noscale';
                    }else{
                        return false;
                    }
                }else if(id_picture_mobile){
                    id_picture = id_picture_mobile;
                    switch(template){
                        case 'image-seo':
                        case 'banner-v3': suffix = 'noscale'; break;
                        default : suffix = '1080x1080';
                    }
                }
            }
            url = app.getPictureUrl(id_picture,'Widget',suffix,format,baseline);

            return url || false;
        },
        getOverlayImage:function(){
            // default picture settings
            var suffix = 'noscale',
                format = 'PNG';

            var model = this,
                id_picture = model.p('image_overlay'),
                baseline = model.get('baseline'),
                url;
            if(app.isMobile()){
                var id_picture_mobile = model.p('overlay_image_mobile');
                if(id_picture_mobile === '0'){
                    // gestion du cas ou 'image_mobile' vaut 0
                    // ça a lieu pour certaines version du template
                    // où le desktop à un arrière-plan, mais le mobile ne doit rien afficher.
                    return false;
                }else if(id_picture_mobile){
                    id_picture = id_picture_mobile;
                    suffix = '300x300';
                }
            }else if( id_picture == 0){
                return false;
            }
            url = app.getPictureUrl(id_picture,'Widget',suffix,format,baseline);

            return url || false;
        },
        getIcon: function(suffix,format){

            // default picture settings
            suffix = suffix ? suffix : '90x90';
            format = format ? format : 'PNG';

            var id_picture = this.p('icon'),
                url = app.getPictureUrl(id_picture,'Widget',suffix,format,'');

            return url || false;
        },
        getVideo: function(){
            if(this.p('videourl') && this.p('videourl') != ''){
                return app.getThemeUrl()+'medias/videos/strat1.mp4';
            }else{
                return false;
            }
        },
        getBgColor: function(){
            return this.p('background_color') || 'transparent';
        },
        getHorizontalAlign: function(){
            return this.p('horizontal_align'+suffixMobile()) || 'center';
        },
        getVerticalAlign: function(){
            return this.p('vertical_align'+suffixMobile()) || 'center';
        },
        getOverlayImageClasses:function(){
            var classes = 'banner-v2-widget__overlay-image';
            if(isMobile()){
                classes += ' banner-v2-widget__overlay-image--'+this.p('overlay_image_mobile_resize');
            }
            return classes;
        }

    })
})
;
